/*
 * @Author: Alex Dong
 * @Date:   2022-06-07 18:34:09
 * @Last Modified by:   Alex Dong
 * @Last Modified time: 2022-06-07 18:35:15
 */
/* Custom code js for your theme here */

/* Example custom before change option variant: */
/*
$('body').on('beforeVariantUpdated', function (e) {
    console.log('beforeVariantUpdated');
});
/*

/* Example custom after change option variant: */
/*
$('body').on('afterVariantUpdated', function (event, $variant) {
    if(!$variant) $variant = event.originalEvent.detail;
    console.log($variant);
    console.log('Variant id: ' + $variant.id);
    console.log('Variant Price: ' + $variant.price);
    console.log('Variant Sku: ' + $variant.sku);
});
*/

/* Example custom after ajax add to cart : */
/*
$('body').on('ajax:addToCart', function (e, $data) {
    console.log($data.form);
    console.log($data.response);
    /* yampiClick(); /*
});
*/

(function () {
  function createDetail(label, href, text) {
    var row = document.createElement('div');
    var strong = document.createElement('strong');
    var link = document.createElement('a');

    strong.textContent = label + ': ';
    link.href = href;
    link.textContent = text;
    if (href.indexOf('http') === 0) {
      link.target = '_blank';
      link.rel = 'noopener';
    }

    row.appendChild(strong);
    row.appendChild(link);
    return row;
  }

  function addDetail(meta, label, href, text) {
    if (!meta || meta.querySelector('a[href="' + href + '"]')) return;
    meta.appendChild(createDetail(label, href, text));
  }

  function enhanceCommunityGroups() {
    var communityPage = document.querySelector('.community-page');
    if (!communityPage) return;

    var cards = communityPage.querySelectorAll('.flyer-card');

    cards.forEach(function (card) {
      var title = card.querySelector('.flyer-title');
      var meta = card.querySelector('.flyer-meta');
      if (!title || !meta) return;

      var titleText = title.textContent || '';

      if (titleText.indexOf('McMillan Boxing Club') !== -1) {
        addDetail(meta, 'Email', 'mailto:McMillanBoxing2019@outlook.com', 'McMillanBoxing2019@outlook.com');
        addDetail(meta, 'Instagram', 'https://www.instagram.com/mcmillanboxingclub2019/', '@mcmillanboxingclub2019');
        addDetail(meta, 'Facebook', 'https://www.facebook.com/McMillanboxingandfitness2019', 'McMillanboxandfitness2019');
      }

      if (titleText.indexOf('Coco') !== -1) {
        addDetail(meta, 'Facebook', 'https://www.facebook.com/100089121996749/', "Coco's Kitchen Dog Bakery & Deli");
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceCommunityGroups);
  } else {
    enhanceCommunityGroups();
  }
})();
